var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "email-custom-template-toolbar" },
        [
          _c("CompassButton", {
            ref: "emailCustomTemplateToolBarButton",
            attrs: {
              label: _vm.$t.__(
                "email.EmailCustomTemplateToolbar.label_btn_use_template"
              ),
              dropdown: true,
              loading:
                _vm.isLoadingGetTemplates ||
                _vm.isLoadingAddTemplateOnContentEmail,
              type: "secondary",
              size: "small",
              "data-bot": "email-custom-template-toolbar__button"
            },
            on: {
              click: function($event) {
                return _vm.updateDropdownVisibility(!_vm.showDropdown)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "CompassDropdown",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.handleClickOutside,
                  expression: "handleClickOutside"
                }
              ],
              key:
                "emailCustomTemplateToolBarDropdown-" +
                (_vm.currentTemplate ? _vm.currentTemplate.id : "none"),
              attrs: {
                parentRef: "emailCustomTemplateToolBarButton",
                dropdownClass: "email-custom-template-toolbar__dropdown",
                placement: "top-end",
                isVisible: _vm.showDropdown,
                value: [_vm.currentTemplate ? _vm.currentTemplate.id : null],
                actions: [
                  {
                    label: _vm.$t.__(
                      "email.emailCustomTemplate.EmailCustomTemplateToolbar.dropdown.more_options"
                    ),
                    callback: function() {
                      _vm.showModal = true
                      _vm.showDropdown = false
                    }
                  }
                ],
                noResultsLabel: _vm.$t.__("common.labels.no_result"),
                filterablePlaceholder: _vm.$t.__("common.actions.search"),
                filterable: ""
              }
            },
            _vm._l(_vm.templates, function(template) {
              return _c("CompassDropdownOption", {
                key: template.id,
                attrs: { label: template.name, value: template.id },
                on: {
                  click: function($event) {
                    return _vm.addTemplateOnContentEmail(template.id)
                  }
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("EmailCustomTemplateModal", {
        attrs: {
          visible: _vm.showModal,
          templates: _vm.templates,
          selectedTemplate: _vm.selectedTemplate,
          initCurrentRoute: _vm.initCurrentRoute,
          isLoadingGetTemplates: _vm.isLoadingGetTemplates,
          isLoadingSelectTemplate: _vm.isLoadingSelectTemplate,
          isLoadingAddTemplateOnContentEmail:
            _vm.isLoadingAddTemplateOnContentEmail
        },
        on: {
          selectTemplate: _vm.selectTemplate,
          addTemplateOnContentEmail: _vm.addTemplateOnContentEmail,
          close: _vm.handleCloseModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }